import { render } from "./ReporteVentas.vue?vue&type=template&id=138320aa&scoped=true"
import script from "./ReporteVentas.vue?vue&type=script&lang=js"
export * from "./ReporteVentas.vue?vue&type=script&lang=js"

import "./ReporteVentas.vue?vue&type=style&index=0&id=138320aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138320aa"]])

export default __exports__